import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import {
	selectCancellationDateFormatted,
	selectCancellationFlags,
	selectCancellationTimeFormatted,
	selectRateData,
} from '@acorn-portal/shared/src/store/cancellation/cancellation.selectors';
import type { OrdinalDisplayDateTime } from '@acorn-portal/shared/src/utils/format-iso-to-ordinal-date-and-time';
import { formatIsoToOrdinalDateAndTimeOrNull } from '@acorn-portal/shared/src/utils/format-iso-to-ordinal-date-and-time';

export interface UseCancellationDateDisplayReturn {
	showImmediateCancellationMessage: boolean;
	requested: OrdinalDisplayDateTime;
	actual: OrdinalDisplayDateTime | null;
}

/** Shared cancellation date/time values for confirmation and success pages. */
export const useCancellationDateDisplay = (): UseCancellationDateDisplayReturn => {
	const { isNow, isStale } = useAppSelector(selectCancellationFlags);
	const requested = {
		date: useAppSelector(selectCancellationDateFormatted),
		time: useAppSelector(selectCancellationTimeFormatted),
	};
	const rateData = useAppSelector(selectRateData);

	return {
		showImmediateCancellationMessage: isNow || isStale,
		requested,
		actual: formatIsoToOrdinalDateAndTimeOrNull(rateData?.actualCancellationDate),
	};
};
